export const DevicesInitialSensorFields = {
  device_id: '',
  id: '',
  synced_at: '',
  location: '',
  name: '',
  pastLocations: [],
};

export const DevicesQRCodeLinkKey = 'newDevice'
// export const DevicesQRCodeLinkKey = 'serial_number'
